// extracted by mini-css-extract-plugin
export default {"container":"Welcome_container__PoQL9","texto":"Welcome_texto__--WxO","logo":"Welcome_logo__ndrsS"};